var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPath2520(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.291 18.0734H14.284V13.3644C14.284 12.2414 14.264 10.7964 12.72 10.7964C11.154 10.7964 10.914 12.0194 10.914 13.2834V18.0734H7.908V8.38936H10.795V9.71236H10.835C11.424 8.70636 12.518 8.10536 13.683 8.14836C16.731 8.14836 17.292 10.1534 17.292 12.7604L17.291 18.0734ZM4.515 7.06536C3.551 7.06536 2.77 6.28436 2.77 5.32036C2.77 4.35636 3.551 3.57536 4.515 3.57536C5.479 3.57536 6.26 4.35636 6.26 5.32036C6.26 6.28436 5.479 7.06536 4.515 7.06536ZM6.018 18.0734H3.008V8.38936H6.018V18.0734ZM18.79 0.783363H1.497C0.68 0.774363 0.01 1.42936 0 2.24636V19.6104C0.01 20.4284 0.68 21.0834 1.497 21.0744H18.79C19.609 21.0844 20.282 20.4294 20.293 19.6104V2.24536C20.281 1.42636 19.608 0.771363 18.79 0.782363",
    fill: "url(#paint0_linear_1777_890)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1777_890",
    x1: 0,
    y1: 0.782227,
    x2: 20.2922,
    y2: 21.0752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03085D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501945,
    stopColor: "#248694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB831"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath2520);
export default __webpack_public_path__ + "static/media/Path_2520.e456467483d1a0ed085c17f809772f4f.svg";
export { ForwardRef as ReactComponent };